import React from 'react';
import { Input, Select, DatePicker, Space, Button } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

const SearchHeader = ({
  onSearch,
  onClear,
  searchConfig = {
    text: true,
    status: false,
    date: false,
    batch: false,
    express: false
  },
  statusOptions = [],
  batchOptions = [],
  loading = false,
  style,
  value = ''
}) => {
  const [searchText, setSearchText] = React.useState(value);
  const [status, setStatus] = React.useState(undefined);
  const [dateRange, setDateRange] = React.useState(null);
  const [dateField, setDateField] = React.useState('created_at');
  const [batchId, setBatchId] = React.useState(undefined);
  const [expressNumber, setExpressNumber] = React.useState('');

  // Date field options for airwaybill filtering
  const dateFieldOptions = [
    { value: 'created_at', label: '创建时间' },
    { value: 'departure_date', label: '起飞时间' },
    { value: 'arrival_date', label: '实际到港时间' },
    { value: 'document_send_time', label: '资料发送时间' },
    { value: 'airport_pickup_time', label: '机场提货时间' },
    { value: 'document_review_time', label: '审单时间' },
    { value: 'processing_time', label: '过机时间' },
    { value: 'customs_clearance_time', label: '清关放行时间' },
    { value: 'courier_pickup_time', label: '快递揽件时间' }
  ];

  const handleSearch = () => {
    onSearch({
      searchText,
      status,
      dateRange,
      dateField,
      batchId,
      expressNumber
    });
  };

  const handleClear = () => {
    setSearchText('');
    setStatus(undefined);
    setDateRange(null);
    setDateField('created_at');
    setBatchId(undefined);
    setExpressNumber('');
    onClear();
  };

  const handleSearchTextChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="toolbar-container" style={style}>
      <Space wrap size={8}>
        {searchConfig.text && (
          <Input
            placeholder="搜索..."
            value={searchText}
            onChange={handleSearchTextChange}
            onKeyPress={handleKeyPress}
            style={{ width: 270 }}
            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
            allowClear
            size="middle"
            className="search-input"
          />
        )}

        {searchConfig.status && (
          <Select
            placeholder="状态"
            value={status}
            onChange={setStatus}
            style={{ width: 120 }}
            allowClear
            options={statusOptions}
            size="middle"
          />
        )}

        {searchConfig.date && (
          <>
            <RangePicker
              value={dateRange}
              onChange={setDateRange}
              style={{ width: 240 }}
              size="middle"
            />
            <Select
              placeholder="日期字段"
              value={dateField}
              onChange={setDateField}
              style={{ width: 120 }}
              options={dateFieldOptions}
              size="middle"
            />
          </>
        )}

        {searchConfig.batch && (
          <Select
            placeholder="批次"
            value={batchId}
            onChange={setBatchId}
            style={{ width: 150 }}
            allowClear
            options={batchOptions}
            size="middle"
          />
        )}

        {searchConfig.express && (
          <Input
            placeholder="快递单号"
            value={expressNumber}
            onChange={(e) => setExpressNumber(e.target.value)}
            style={{ width: 150 }}
            allowClear
            size="middle"
          />
        )}

        <Button
          type="primary"
          onClick={handleSearch}
          loading={loading}
          icon={<SearchOutlined />}
          size="middle"
        >
          搜索
        </Button>

        <Button
          onClick={handleClear}
          icon={<ClearOutlined />}
          size="middle"
        >
          清除
        </Button>
      </Space>
    </div>
  );
};

export default SearchHeader;
